import { Action, ActionReducer, combineReducers } from '@ngrx/store';
import { EmissionPointsWithParametersView } from '../../../_generated';
import { EmissionPointsRequestStatusAction } from '../../actionstypes/emission-points/emission-points-request-status.actiontype';
import { RequestStatus } from '../../actionstypes/request-status/request-status.actiontype';
import requestStatusReducer from '../request-status/request-status.reducer';
import emissionPointsReducer from './emission-points.reducer';

export interface RootEmissionPoints {
  requestStatus: RequestStatus;
  data: EmissionPointsWithParametersView[];
}

export const emissionPointsRootReducer = combineReducers({
  requestStatus: requestStatusReducer(
    EmissionPointsRequestStatusAction.Load,
    EmissionPointsRequestStatusAction.Success,
    EmissionPointsRequestStatusAction.Error,
  ),
  data: emissionPointsReducer as ActionReducer<EmissionPointsWithParametersView[], Action<string>>,
});
